import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch } from 'vue';
import CInput from '@/components/shared/CInput.vue';
import type { ImagePlaceholderElement, WordSearchConfig } from '@/typings/customilyElements/canvasElements';


export default /*#__PURE__*/_defineComponent({
  __name: 'GridProperties',
  props: {
    imageElement: null,
    editMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    imageElement?: ImagePlaceholderElement;
    editMode?: boolean;
};



const model = reactive({
    gridCols: 20,
    gridRows: 20
});

const clampValue = (value: number, min = 5, max = 50): number => {
    return Math.max(min, Math.min(max, value));
};

watch(
    () => props.imageElement,
    (element) => {
        if (!element || !element.wordSearchConfig) return;

        const config = element.wordSearchConfig;
        model.gridCols = clampValue(config.gridCols ?? 20);
        model.gridRows = clampValue(config.gridRows ?? 20);
    },
    { immediate: true }
);

const disabled = computed(() => !!props.imageElement?.locked);

const updateGridCols = (value = 0) => {
    const clampedValue = clampValue(value);
    model.gridCols = clampedValue;
    updateWordSearchConfig({ gridCols: clampedValue });
};

const updateGridRows = (value = 0) => {
    const clampedValue = clampValue(value);
    model.gridRows = clampedValue;
    updateWordSearchConfig({ gridRows: clampedValue });
};

const updateWordSearchConfig = (config: Partial<WordSearchConfig>) => {
    const element = props.imageElement;
    if (!element) return;

    const newConfig = { ...element.wordSearchConfig, ...config } as WordSearchConfig;
    element.set('wordSearchConfig', newConfig);
    if (props.editMode) element.setEditedProp('wordSearchConfig');
};

return { __sfc: true,props, model, clampValue, disabled, updateGridCols, updateGridRows, updateWordSearchConfig, CInput }
}

})